import React, { useState, useEffect } from "react";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Slider } from "primereact/slider";
import { InputNumber } from "primereact/inputnumber";
import {useTranslation} from "react-i18next";

type MeasurementProps = {
  onPrevious: () => void;
  onNext: () => void;
};
function Measurement(props: MeasurementProps) {
  const { t } = useTranslation();

  const [measurementUnit, setMeasurementUnit] = useState<any>();
  const [measurementRange, setMeasurementRange] = useState<any>();
  const [samplingRate, setSamplingRate] = useState<any>();
  const [sampleRate, setSampleRate] = useState<any>([]);
  const [traceLength, setTraceLength] = useState<any>(5120);
  const [pretriggerLength, setPretriggerLength] = useState<any>(1024);
  const [offsetRemover, setOffsetRemover] = useState<any>();
  const [microphoneChannel, setMicrophoneChannel] = useState<any>();
  const [powerSave, setPowersave] = useState<any>();
  const [measurementType, setMeasurementType] = useState<any>();
  const [triggerX, setTriggerX] = useState<any>(1.0);
  const [triggerY, setTriggerY] = useState<any>(1.0);
  const [triggerZ, setTriggerZ] = useState<any>(1.0);
  const [triggerVR, setTriggerVR] = useState<any>(1.0);
  const [autoTrigger, setAutoTrigger] = useState<any>(0);
  const [axisAutoRotation, setAxisAutoRotation] = useState<any>();
  const [rotationX, setRotationX] = useState<any>(0);
  const [rotationY, setRotationY] = useState<any>(0);
  const [rotationZ, setRotationZ] = useState<any>(0);
  const [slowTrace, setSlowTrace] = useState<any>(60);
  const [isTriggerDisable, setIsTriggerDisable] = useState<boolean>(false);
  const [isRotationDisable, setIsRotationDisable] = useState<boolean>(true);

  const [errors, setErrors] = useState<any>([]);

  const measurement_unit = [
    { name: "g", value: 0 },
    { name: "mm/s²", value: 1 },
    { name: "mm/s", value: 2 },
  ];
  const measurement_range = [
    { name: "+/- 2g", value: 1 },
    { name: "+/- 4g", value: 2 },
    { name: "+/- 8g", value: 3 },
  ];

  const sampling_rate = [
    { name: "4000 Hz", value: 0 },
    { name: "2000 Hz", value: 1 },
    { name: "1000 Hz", value: 2 },
    { name: "500 Hz", value: 3 },
    { name: "250 Hz", value: 4 },
    { name: "125 Hz", value: 5 },
    { name: "62,5 Hz", value: 6 },
    { name: "31,25 Hz", value: 7 },
    { name: "15,625 Hz", value: 8 },
    { name: "7,831 Hz", value: 9 },
    { name: "3,906 Hz", value: 10 },
  ];

  const offset_remover = [
    { name: "off", value: 0 },
    { name: "on", value: 1 },
  ];

  const microphone_channel = [
    { name: "off", value: 0 },
    { name: "on", value: 1 },
  ];

  const power_save = [
    { name: "off", value: 0 },
    { name: "on", value: 1 },
  ];

  const measurement_type = [
    { name: "continuous", value: 0 },
    { name: "triggered", value: 1 },
  ];

  const axis_rotation = [
    { name: "off", value: 0 },
    { name: "fixed manual", value: 1 },
    { name: "fixed automatic", value: 2 },
    { name: "dynamic", value: 3 },
  ];

  const validate = () => {
    let error: any = {};
    if (traceLength === "" || traceLength === null) {
      error["traceLength"] = t('traceLength_error');
      setErrors(error);
    }
    if(traceLength < 10 || traceLength > 120){
      error["traceLength"] = t('traceLength_limit_error');
      setErrors(error);
    }
    if (pretriggerLength === "" || pretriggerLength === null) {
      error["pretriggerLength"] = t('pretriggerLength_error');
      setErrors(error);
    }
    if(pretriggerLength < 0 || pretriggerLength > 119){
      error["pretriggerLength"] = t('preTriggerLength_limit_error');
      setErrors(error);
    }
    if(pretriggerLength){
      if(traceLength <= pretriggerLength){
        error["traceLength"] = t('tracelength_greater_error');
        setErrors(error);
      }
    }
    if (triggerX === null || triggerX === 0 || triggerX < 0) {
      error["triggerX"] = t('triggerX_error');
      setErrors(error);
    }
    if (triggerY === null || triggerY === 0 || triggerY < 0) {
      error["triggerY"] = t('triggerY_error');
      setErrors(error);
    }
    if (triggerZ === null || triggerZ === 0 || triggerZ < 0) {
      error["triggerZ"] = t('triggerZ_error');
      setErrors(error);
    }
    if (autoTrigger === "" || autoTrigger === null) {
      error["autoTrigger"] = t('autoTrigger_error');
      setErrors(error);
    }
    if (samplingRate === "" || samplingRate === undefined) {
      error["samplingRate"] = t('samplingRate_error');
      setErrors(error);
    }
    if (Object.keys(error).length !== 0) {
      return false;
    }

    return true;
  };

  useEffect(() => {
    let measurement = localStorage.getItem("measurements");
    if (measurement) {
      let jsonItem = JSON.parse(measurement);
      setMeasurementUnit(jsonItem["measurementUnit"]);
      setMeasurementRange(jsonItem["measurementRange"]);
      setSamplingRate(jsonItem["samplingRate"]);
      setTraceLength(jsonItem["traceLength"]);
      setPretriggerLength(jsonItem["pretriggerLength"]);
      setOffsetRemover(jsonItem["offsetRemover"]);
      setMicrophoneChannel(jsonItem["microphoneChannel"]);
      setPowersave(jsonItem['powerSave']);
      if(jsonItem["measurementType"] === 0){
        setIsTriggerDisable(true)
      }
      setMeasurementType(jsonItem["measurementType"]);
      setTriggerX(jsonItem["triggerX"]);
      setTriggerY(jsonItem["triggerY"]);
      setTriggerZ(jsonItem["triggerZ"]);
      setTriggerVR(jsonItem["triggerVR"]);
      setAutoTrigger(jsonItem["autoTrigger"]);
      setAxisAutoRotation(jsonItem["axisAutoRotation"]);
      if(+jsonItem["axisAutoRotation"] === 1){
        setIsRotationDisable(false);
      }
      else{
        setIsRotationDisable(true);
      }
      setRotationX(jsonItem["rotationX"]);
      setRotationY(jsonItem["rotationY"]);
      setRotationZ(jsonItem["rotationZ"]);
      setSlowTrace(jsonItem["slowTrace"]);
    }
    let projectInfo:any = localStorage.getItem('projectInfo')!;
    if(projectInfo){
      let info = JSON.parse(projectInfo);
      if(info['norm'] === 'DIN 4150-2 (1-80 Hz)'){
        setSampleRate([
          { name: "1000 Hz", value: 2 },
          { name: "500 Hz", value: 3 },
          { name: "250 Hz", value: 4 },
          { name: "125 Hz", value: 5 },
          { name: "62,5 Hz", value: 6 },
          { name: "31,25 Hz", value: 7 },
          { name: "15,625 Hz", value: 8 },
          { name: "7,831 Hz", value: 9 },
          { name: "3,906 Hz", value: 10 },
        ]);
      }
      else if(info['norm'] === 'DIN 4150-3 (1-80 Hz)'){
        setSampleRate([
          { name: "2000 Hz", value: 1 },
          { name: "4000 Hz", value: 0 },
        ]);
      }
      else if(info['norm'] === 'Custom' || info['norm'] === 'DIN 4150-3 (1-315 Hz)'){
        setSampleRate([
          { name: "4000 Hz", value: 0 },
          { name: "2000 Hz", value: 1 },
          { name: "1000 Hz", value: 2 },
          { name: "500 Hz", value: 3 },
          { name: "250 Hz", value: 4 },
          { name: "125 Hz", value: 5 },
          { name: "62,5 Hz", value: 6 },
          { name: "31,25 Hz", value: 7 },
          { name: "15,625 Hz", value: 8 },
          { name: "7,831 Hz", value: 9 },
          { name: "3,906 Hz", value: 10 },
        ]);
      }
    }
  }, []);

  return (
    <>
      <Card title="Measurement Setting" className="InputForms_container mt-4">
        <div>
          <div className="grid">
            <div className="lg:col-6">
              <h3>General Settings</h3>
              <div className="grid align-items-center pr-3" style={{ border: '2px solid #eee', borderRadius: '8px' }}>
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("measurement_unit")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <Dropdown
                      className="p-inputtext-sm  mb-0"
                      value={measurementUnit}
                      options={measurement_unit}
                      onChange={(e) => setMeasurementUnit(e.value)}
                      optionLabel="name"
                      placeholder="Select Measurement Unit"
                  />
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("measurement_range")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <Dropdown
                      className="p-inputtext-sm  mb-0"
                      value={measurementRange}
                      options={measurement_range}
                      onChange={(e) => setMeasurementRange(e.value)}
                      optionLabel="name"
                      placeholder="Select Measurement Range"
                  />
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("sampling_rate")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <Dropdown
                      className="p-inputtext-sm  mb-0"
                      value={samplingRate}
                      options={sampleRate}
                      onChange={(e) => setSamplingRate(e.value)}
                      optionLabel="name"
                      placeholder="Select Sampling Rate"
                  />
                </div>
                {errors["samplingRate"] && <div className="col-12"><p className="error-message">{errors["samplingRate"]}</p></div>}
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("measurement_type")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <Dropdown
                      className="p-inputtext-sm  mb-0"
                      value={measurementType}
                      options={measurement_type}
                      onChange={(e) => {
                        setMeasurementType(e.value)
                        if (e.value === 0)
                          setIsTriggerDisable(true);
                        else
                          setIsTriggerDisable(false);
                      }}
                      optionLabel="name"
                      placeholder="Select Measurement Type"
                  />
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("slow_trace")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <div className="grid" style={{ float: "right" }}>
                    <span className="rotation-value"> {slowTrace}</span>
                  </div>
                  <Slider
                      className="p-inputtext-sm block mb-0 mt-3"
                      value={slowTrace}
                      min={0}
                      max={1440}
                      onChange={(e) => setSlowTrace(e.value)}
                  />
                </div>
              </div>
              <h3>Trigger Settings</h3>
              <div className="grid align-items-center pr-3" style={{ border: '2px solid #eee', borderRadius: '8px' }}>
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("trace_length")} [s]:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <InputNumber
                      className="p-inputtext-sm block mb-0 "
                      value={traceLength}
                      onChange={(e) => setTraceLength(e.value)}
                      useGrouping={false}
                  />
                </div>
                {errors["traceLength"] && <div className="col-12 p-0"> <p className="error-message mb-0">{errors["traceLength"]}</p></div>}
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("pretrigger_length")} [s]:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <InputNumber
                      className="p-inputtext-sm block mb-0 "
                      value={pretriggerLength}
                      onChange={(e) => setPretriggerLength(e.value)}
                      useGrouping={false}
                  />
                </div>
                {errors["pretriggerLength"] && <div className="col-12 p-0"> <p className="error-message mb-0">{errors["pretriggerLength"]}</p></div>}
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("trigger_level_X")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <InputNumber
                      value={triggerX}
                      style={{ marginTop: '6px' }}
                      onChange={(e) => setTriggerX(e.value)}
                      className="p-inputtext-sm block mb-0 "
                      mode="decimal"
                      locale="de-DE"
                      minFractionDigits={1}
                      disabled={isTriggerDisable}
                  />
                  {errors["triggerX"] && <div className="col-12 p-0"> <p className="error-message mb-0">{errors["triggerX"]}</p></div>}
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("trigger_level_Y")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <InputNumber
                      value={triggerY}
                      onChange={(e) => setTriggerY(e.value)}
                      className="p-inputtext-sm block mb-0 "
                      mode="decimal"
                      locale="de-DE"
                      minFractionDigits={1}
                      disabled={isTriggerDisable}
                  />
                  {errors["triggerY"] && <div className="col-12 p-0"><p className="error-message mb-0">{errors["triggerY"]}</p></div>}
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("trigger_level_Z")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <InputNumber
                      value={triggerZ}
                      onChange={(e) => setTriggerZ(e.value)}
                      className="p-inputtext-sm block mb-0 "
                      mode="decimal"
                      locale="de-DE"
                      minFractionDigits={1}
                      disabled={isTriggerDisable}
                  />
                  {errors["triggerZ"] && <div className="col-12 p-0"><p className="error-message mb-0">{errors["triggerZ"]}</p></div>}
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("trigger_level_VR")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <InputNumber
                      value={triggerVR}
                      onChange={(e) => setTriggerVR(e.value)}
                      className="p-inputtext-sm block mb-0 "
                      mode="decimal"
                      locale="de-DE"
                      minFractionDigits={1}
                      disabled={isTriggerDisable}
                  />
                  {errors["triggerVR"] && <div className="col-12 p-0"><p className="error-message mb-0">{errors["triggerVR"]}</p></div>}
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("auto_trigger_interval")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <InputNumber
                      className="p-inputtext-sm block mb-0 "
                      value={autoTrigger}
                      useGrouping={false}
                      onChange={(e) => {
                        setAutoTrigger(e.value);
                      }}
                  />
                  {errors["autoTrigger"] && <div className="col-12 p-0"> <p className="error-message mb-0">{errors["autoTrigger"]}</p></div>}
                </div>

              </div>
            </div>
            <div className="pl-4 lg:col-6">
              <h3>Power Settings</h3>
              <div className="grid align-items-center" style={{ border: '2px solid #eee', borderRadius: '8px' }}>
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("offset_remover")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <Dropdown
                      className="p-inputtext-sm  mb-0"
                      value={offsetRemover}
                      options={offset_remover}
                      onChange={(e) => setOffsetRemover(e.value)}
                      optionLabel="name"
                      placeholder="Select Offset Remover"
                  />
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("microphone_channel")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <Dropdown
                      className="p-inputtext-sm  mb-0"
                      value={microphoneChannel}
                      options={microphone_channel}
                      onChange={(e) => setMicrophoneChannel(e.value)}
                      optionLabel="name"
                      placeholder="Select Microphone Channel"
                  />
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("power_save")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <Dropdown
                      className="p-inputtext-sm  mb-0"
                      value={powerSave}
                      options={power_save}
                      onChange={(e) => setPowersave(e.value)}
                      optionLabel="name"
                      placeholder="Select Power Save"
                  />
                </div>
              </div>
              <h3>Orientation Settings</h3>
              <div className="grid align-items-center pr-3" style={{ border: '2px solid #eee', borderRadius: '8px' }}>
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("axis_auto_rotation")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <Dropdown
                      className="p-inputtext-sm  mb-0"
                      value={axisAutoRotation}
                      options={axis_rotation}
                      onChange={(e) => {
                        setAxisAutoRotation(e.value)
                        if (e.value === 1) {
                          setIsRotationDisable(false)
                        }
                        else {
                          setIsRotationDisable(true)
                          setRotationX(0);
                          setRotationY(0);
                          setRotationZ(0);
                        }
                      }}
                      optionLabel="name"
                      placeholder="Select Axis Auto Rotation"
                  />
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("manual_rotation_X_axis")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <div className="grid" style={{ float: "right" }}>
                    <span className="rotation-value"> {rotationX}</span>
                  </div>
                  <Slider
                      className="p-inputtext-sm block mb-0 mt-3"
                      value={rotationX}
                      min={-180}
                      max={180}
                      onChange={(e) => setRotationX(e.value)}
                      disabled={isRotationDisable}
                  />
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("manual_rotation_Y_axis")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <div className="grid" style={{ float: "right" }}>
                    <span className="rotation-value"> {rotationY}</span>
                  </div>
                  <Slider
                      className="p-inputtext-sm block mb-0 mt-3"
                      value={rotationY}
                      min={-180}
                      max={180}
                      onChange={(e) => setRotationY(e.value)}
                      disabled={isRotationDisable}
                  />
                </div>
                <div className="col-12 lg:col-6">
                  <h5 className="ml-5">{t("manual_rotation_Z_axis")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                  <div className="grid" style={{ float: "right" }}>
                    <span className="rotation-value"> {rotationZ}</span>
                  </div>
                  <Slider
                      className="p-inputtext-sm block mb-0 mt-3"
                      value={rotationZ}
                      min={-180}
                      max={180}
                      onChange={(e) => setRotationZ(e.value)}
                      disabled={isRotationDisable}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-wrap align-items-center justify-content-center lg:justify-content-between">
            <p className="text-danger text-underline"></p>
            <p className="text-danger"></p>
            <div>
              <Button
                icon="pi pi-angle-left"
                label={t("previous")}
                className="p-button-outlined p-button-secondary"
                onClick={() => {
                  props.onPrevious();
                }}
              />

              <Button
                icon="pi pi-angle-right"
                label={t("next")}
                className="p-button-outlined p-button-secondary ml-2"
                iconPos="right"
                onClick={() => {
                  setErrors([]);
                  if (validate()) {
                    let measurements: any = {
                      measurementUnit: measurementUnit,
                      measurementRange: measurementRange,
                      samplingRate: samplingRate,
                      traceLength: traceLength,
                      pretriggerLength: pretriggerLength,
                      offsetRemover: offsetRemover,
                      microphoneChannel: microphoneChannel,
                      powerSave: powerSave,
                      measurementType: measurementType,
                      triggerX: triggerX,
                      triggerY: triggerY,
                      triggerZ: triggerZ,
                      triggerVR: triggerVR,
                      autoTrigger: autoTrigger,
                      axisAutoRotation: axisAutoRotation,
                      rotationX: rotationX,
                      rotationY: rotationY,
                      rotationZ: rotationZ,
                      slowTrace: slowTrace,
                    };

                    localStorage.setItem(
                      "measurements",
                      JSON.stringify(measurements)
                    );
                    props.onNext();
                  }
                }}
              />
            </div>
          </div>
        </div>
      </Card>
    </>
  );
}
export default Measurement;
